import { render, staticRenderFns } from "./PatentAndTrademarkOutput.vue?vue&type=template&id=4a0efb7f&"
import script from "./PatentAndTrademarkOutput.vue?vue&type=script&lang=js&"
export * from "./PatentAndTrademarkOutput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/eneforhandler/components/contract/PatentAndTrademarkOutput.vue
// module id = null
// module chunks = 